import { always, forEachObjIndexed, tryCatch } from 'ramda';

const getColors = () => tryCatch(
	colorString => JSON.parse(colorString),
	always({}),
)(process.env.COLORS);

export const injectCssVariables = () => {
	const colors = getColors();
	const root = document.documentElement;
	forEachObjIndexed(
		(color, key) => {
			root.style.setProperty(`--app-color-${key}`, color);
		},
		colors,
	);
};

export const injectTextColors = () => {
	const colors = getColors();
	const style = document.createElement('style');
	let cssTextClasses = '';
	style.type = 'text/css';
	forEachObjIndexed(
		(color, key) => { cssTextClasses += ` .text-${key} { color: ${color} !important; }`; },
		colors,
	);
	style.innerHTML = cssTextClasses;
	document.getElementsByTagName('head')[0].appendChild(style);
};



// WEBPACK FOOTER //
// ./src/utils/dynamic-css.js